import { IconButton, IconButtonProps, Tooltip } from '@wix/design-system';
import classNames from 'classnames';
import React, { FC } from 'react';

import { useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { Page } from '../../../common/types';
import { renderModel } from '../../../util/renderModel';
import { getThemeTraits } from '../../../util/widgetTheme';
import s from './styles.scss';

const isEditor3 = getThemeTraits().editor3Layout;
const isStudioEditor = getThemeTraits().studioLayout;

type HeaderActionsIconProps = IconButtonProps & {
  children: React.ReactNode;
  tooltipContent?: string;
};

export const HeaderActionsIcon: FC<HeaderActionsIconProps> = ({
  children,
  tooltipContent,
  className,
  ...iconButtonProps
}) => {
  const isMobile = renderModel.isMobile();
  const currentPage = useCurrentPage();
  const isChatbotPage = currentPage === Page.Chatbot;

  const getIconSize = () => {
    if (!isEditor3) {
      return isChatbotPage ? 'tiny' : 'small';
    }
    return 'medium';
  };
  const iconButton = (
    <IconButton
      size={getIconSize()}
      skin={isStudioEditor ? 'dark' : 'transparent'}
      priority={isStudioEditor ? 'tertiary' : undefined}
      {...iconButtonProps}
      className={classNames(s.headerActionsIcon, className)}
    >
      {children}
    </IconButton>
  );

  const shouldWrapWithTooltip = !isMobile && Boolean(tooltipContent);

  return (
    <>
      {shouldWrapWithTooltip ? (
        <Tooltip content={tooltipContent} size="small" className={s.headerActionsTooltip}>
          {iconButton}
        </Tooltip>
      ) : (
        iconButton
      )}
    </>
  );
};
